import React from 'react';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { connect } from 'react-redux';

import Spinner from '../../../../components/Spinner';

import { authenticateUser } from '../../../../store/auth';

class Component extends React.Component {
  componentDidMount() {
    if (this.props.location.query && this.props.location.query.error && this.props.location.query.error.indexOf("user_cancelled")>-1) {
      window.location = "/advisor";
    } else if (this.props.location.query.code) {
      this.props.GetLinkedInMutation({
        variables: {
          AccessToken: this.props.location.query.code,
          redirectUrl: window.location.origin + '/signin/auth/linkedin',
        },
      }).then(LinkedInAccess => { // LinkedIn Access tokens do not work immediately for some reason hence the delay
        window.setTimeout(() => this.props.LinkedInSignIn({
          variables: {
            AccessToken: LinkedInAccess.data.LinkedInSSO.access_token,
          },
        }).then(Response => {
          window.setTimeout(() => {
            window.location.href = ('/' + this.props.location.query.state);
          }, 200);
          this.props.authenticateUser(Response.data.LinkedInSignIn.token);
        }).catch(Err => {
          window.setTimeout(() => {
            window.location.href = ('/' + this.props.location.query.state + '?SigninErr=Linkedin');
          }, 200);
        }), 3000);
      }).catch(LinkedInAccess => this.setState({
        LinkedInAccess: false,
      }));
    }
  }

  render() {
    return (
      <div style={{ padding: '50px' }}>
        <Spinner />
      </div>
    );
  }
}

const GetLinkedInMutation = gql`
mutation (
  $AccessToken: String!
  $redirectUrl: String
) {
  LinkedInSSO(code: $AccessToken, redirectUrl: $redirectUrl) {
    access_token
  }
}`;

const LinkedInSignInMutation = gql`
mutation (
  $AccessToken: String!
) {
  LinkedInSignIn(AccessToken: $AccessToken) {
    token
  }
}
`;

const mapStateToProps = (state) => ({
  authenticatedID: (typeof state.auth.sub !== 'undefined') ? state.auth.sub : null,
  authedUser: state.auth,
});

const mapDispatchToProps = {
  authenticateUser,
};

export default () => ({
  path: 'auth/linkedin',
  component: compose(
    graphql(GetLinkedInMutation, {
      name: 'GetLinkedInMutation'
    }),
    graphql(LinkedInSignInMutation, {
      name: 'LinkedInSignIn'
    })
  )(connect(mapStateToProps, mapDispatchToProps)(Component))
});



// WEBPACK FOOTER //
// ./src/routes/signin/routes/LinkedInSignin/index.js